<template>
  <div class="m-tech-page-content">
    <ul class="mb-list">
      <li>
        <div class="img-wraper">
          <img src="../../static/images/mobile/technology/Biometrics.jpg" alt="生物识别" />
        </div>
        <h2 class="title-bg title-black" subtitle="Biometrics">生物识别</h2>
        <p>我们应用目前学术界最前沿的基于深度学习理论的生物识别技术，尤其在人脸识别、指纹识别、指静脉识别领域进行了行业应用的优化，实现快速、精准的身份识别和资格认证。广泛应用于人社、安防、金融等领域。</p>
      </li>
      <li>
        <div class="img-wraper">
          <img src="../../static/images/mobile/technology/Natural language.jpg" alt="自然语言处理" />
        </div>
        <h2 class="title-bg title-black" subtitle="Natural language">自然语言处理</h2>
        <p>我们依托机器学习和行业海量数据积累，定义行业语义模型，识别和理解自然语言，达到用户与系统进行自然交互的效果。被广泛应用于人社公共服务智能问答领域。</p>
      </li>
      <li>
        <div class="img-wraper">
          <img src="../../static/images/mobile/technology/Deep learning.jpg" alt="深度学习" />
        </div>
        <h2 class="title-bg title-black" subtitle="Deep learning">深度学习</h2>
        <p>我们应用多层神经网络的机器学习算法，处理图像、文本、语言等非结构化数据，形成生物识别、知识检索、语义理解等算法，并支持算法的持续改善，支撑各类应用能力的持续提升。</p>
      </li>
      <li>
        <div class="img-wraper">
          <img src="../../static/images/mobile/technology/Knowledge Graph.jpg" alt="知识图谱" />
        </div>
        <h2 class="title-bg title-black" subtitle="Knowledge Graph">知识图谱</h2>
        <p>我们通过对行业知识的分析，把复杂的知识通过数据挖掘、信息处理、知识计量和图形绘制而显示出来，揭示知识之间的关联关系及动态发展规律。应用于智能知识库领域以提升知识生成的智能化水平。</p>
      </li>
      <li>
        <div class="img-wraper">
          <img src="../../static/images/mobile/technology/Big Data.jpg" alt="智能大数据" />
        </div>
        <h2 class="title-bg title-black" subtitle="Big Data">智能大数据</h2>
        <p>我们从各种结构化和非结构化数据源中筛选信息，深度分析发掘数据间关系，帮助用户改善认知过程，应用于智能推荐及“三医联动”新局面下的数据服务产品。</p>
      </li>
    </ul>
  </div>
</template>

<script>

  export default {
    data () {
      return { }
    },
    methods: {

    },
    components: {
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .m-tech-page-content {
    background: #f7f7f7;
    .pulic-banner-container{
      background-image: url('../assets/images/banners/bg-m-tech.jpg');
    }
  }
</style>



// WEBPACK FOOTER //
// src/mobile/Technology.vue